import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input  } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import {GridOptions, GridApi, ColumnApi} from "ag-grid";
import { AgGridNg2 } from 'ag-grid-angular';
import { DataService } from '../../../../services/data/data.service';
import { Subscription } from "rxjs";
import { OrderPnlCellRenderer } from '../orderPnlCellRenderer.component';
import { OrderPipsCellRenderer } from '../orderPipsCellRenderer.component';


@Component({
  selector: 'app-tradeskPositionsTab',
  template: require('./tradeskPositionsTab.component.html'),
  styles: [require('./tradeskPositionsTab.component.css')]
})
export class tradeskPositionsTabComponent implements AfterViewInit {

  @ViewChild('ordersGrid') ordersGrid: any;

  private _ordersInputData:any;
  @Input()
  public set ordersDataInput(v: any) {

      console.log("ORDERS");
      console.log(v);
      this._ordersInputData = v;
  }
  public get ordersDataInput(): any {
      return this._ordersInputData;
  }

  columnDefs = [
    {headerName: 'Symbol', field: 'symbol', filter: "agTextColumnFilter"},
    {headerName: 'Direction', field: 'direction', filter: "agTextColumnFilter"},
    {headerName: 'Submitted Time', field: 'stime', filter: "agDateColumnFilter"},
    {headerName: 'Quantity', field: 'qty', filter: "agNumberColumnFilter"},
    {headerName: 'Price', field: 'entryprice' , filter: "agNumberColumnFilter"},
    {headerName:'Pips', cellRendererFramework: OrderPipsCellRenderer,cellRendererParams: {}},
    {headerName:'UPL USD', cellRendererFramework: OrderPnlCellRenderer,cellRendererParams: {}}
];

  public gridOptions: GridOptions;
  //private gridAPI:GridApi;
  constructor(private elRef:ElementRef, private dataService: DataService) { 

            this.gridOptions = <GridOptions>{};

            if(this.gridOptions)
            {
            //  this.gridAPI = this.gridOptions.api
            }
            

            this.gridOptions.defaultColDef={
            // set every column width
            cellClass: 'orders-cell',
            width:150
            };

            this.gridOptions.enableFilter = true;
            /*
            for(var l=0;l<3;l++)
              {
                var t:IOrdersData ={
                                    id:l++,
                                    status: "Pending",
                                    symbol:"EUR/USD",
                                    direction:"buy",
                                    stime:" ",
                                    type:"Market",
                                    quantity:10,
                                    submittedprice:4.00,
                                    lastpx:2
                                  };
                this.addRow(t);
              }
            */
           dataService.dataSubscriber.subscribe(response => {
            if (response)
            {
                if(response.OrderUpdate!=null)
                {
                  if(this.gridApi){
                    this.gridApi.setRowData([]);
                  }                  
            //      console.log(response.OrderUpdate.OpenPositions);
                  this.addItems(response.OrderUpdate.OpenPositions);
                //  this.filledOrders = response.OrderUpdate.FilledOrders;
                  //  this.positionsOrders = response.OrderUpdate.OpenPositions;
                   //   this.WorkingOrders = response.OrderUpdate.WorkingOrders;
                }
            }
        });
   }

   ngAfterViewInit() {

  }
  
  private gridApi: GridApi | undefined;
  private gridColumnApi: ColumnApi | undefined;

  public onGridReady(params:GridOptions) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }


  addItems(v:any) {
    var newItems:any[] =[];

    v.forEach((element:any) => {
      var t:IPositionsData ={
        symbol:element.Symbol,
        direction:element.Side,
        stime:element.Timestamp,
        entryprice:element.Price,
        qty:element.Quantity
      };
      newItems.push(t);
  });
 // console.log(newItems);
 if(this.gridApi){
  var res = this.gridApi.updateRowData({ add: newItems });
}    
   // printResult(res);
  }


  onAddRow() {
    /*
    var l=100;
    var t:IPositionsData ={
      id:l++,
   //   status: "Pending_s",
      symbol:"EUR/USD",
      direction:"buy",
      stime:" ",
      type:"Market",
   //   quantity:10,
      submittedprice:4.00,
   //   lastpx:2
    };
    var newItem = t;
    var res = this.gridApi.updateRowData({ add: [newItem] });
   // this.addItems();
   // printResult(res);
   */
  }


  public ordersData:IPositionsData[]=[];


  public addRow( data:IPositionsData)
  {
    this.ordersData.push(data);
  }

}


export interface IPositionsData
{
  symbol:string,
  direction:string,
  stime:string,
  entryprice:number,
  qty:number,
}
